<template>
  <div class="shop-content">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <div class="notice-content">
      <van-list v-model="loading" :finished="finished" finished-text="已加载全部" @load="onReachBottom">
        <notice-list v-if="!isEmpty" :list.sync="noticeList"></notice-list>
        <emptyData v-if="isEmpty" message="暂时没有服务通知"></emptyData>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getMessageList, postEessageEdit } from '@/api/user'
import PhHeader from '@/components/common/Header'
import NoticeList from '@/components/business/NoticeList'
import EmptyData from '@/components/business/EmptyData'

export default {
  name: 'shopNotice',
  components: {
    PhHeader,
    NoticeList,
    EmptyData
  },
  data () {
    return {
      noticeList: [],
      page: 1,
      pageTotal: 0,
      total: 0,
      loading: false,
      finished: false,
      isEmpty: false
    }
  },
  created() {
    postEessageEdit({ userToken: this.$store.getters.token }).then(res => {
    }).catch(error => {
      this.$toast(error)
    })
    this.getData(true);
  },
  methods: {
    // 获取数据
    getData(refresh) {
      var data = {
        pageIndex: this.page,
        userToken: this.$store.getters.token
      }
      this.loading = true
      getMessageList(data).then(res => {
        if (refresh) {
          this.noticeList = res.result || []
        } else {
          this.noticeList = [...this.noticeList, ...res.result]
        }
        this.total = res.total
        this.pageTotal = res.pageCount
        if (this.noticeList.length == 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    // 加载更多
    onReachBottom () {
      if(this.noticeList.length > 0) {
        if (this.page >= this.pageTotal) { // 已经到底部
          this.finished = true
          this.loading = false;
        } else {
          this.page++
          setTimeout(() => {
            this.getData()
          }, 300)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
